module.exports = __webpack_public_path__ + "static/img/icon02.2ba69c96.svg";